import React from "react";
import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectSideBySideValue } from "state/selections/selector";
import { titleCase } from "@ls/js-utils";
import {
  selectDefinitions,
  selectFetchingAnalyticsData,
  selectFetchingAnalyticsSbsData,
} from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import { deleteColumn } from "state/grid/actions";

const getDefaultColumnDef = (analytic) => {
  switch (analytic) {
    case "spread":
    case "LSpropOptionAdjustedSpread":
    case "liborSpread":
      return {
        X_decimal: 0,
        X_formatType: "NUMBER",
      };
    case "weight":
      return {
        X_decimal: 2,
        X_formatType: "PERCENTAGE",
      };
    default:
      return {};
  }
};

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(
    selectFetchingAnalyticsData(SummaryType.ABSOLUTE),
  );
  const fetchingRelData = useSelector(
    selectFetchingAnalyticsData(SummaryType.RELATIVE),
  );
  const fetchingAbsSbsData = useSelector(
    selectFetchingAnalyticsSbsData(SummaryType.ABSOLUTE),
  );
  const fetchingRelSbsData = useSelector(
    selectFetchingAnalyticsSbsData(SummaryType.RELATIVE),
  );
  const sideBySideValue = useSelector(
    selectSideBySideValue(SelectionState.COMMITTED),
  );
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((colDefs, analyticDefinition) => {
      const { analytic, summary, scaleType } = analyticDefinition;
      const colId = `${analytic},${summary},${scaleType}`;
      const colDef = {
        field: colId,
        colId: colId,
        headerName: `${titleCase(analytic)} ${titleCase(summary === "ABSOLUTE" ? "" : summary)} ${titleCase(scaleType)}`,
        loading:
          (summary === SummaryType.ABSOLUTE && fetchingAbsData) ||
          (summary === SummaryType.BENCHMARK && fetchingAbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelData),
        X_onDelete: () => dispatch(deleteColumn(analyticDefinition)),
        ...getDefaultColumnDef(analytic),
      };
      colDefs.push(colDef);

      if (sideBySideValue) {
        const sbsColDef = {
          ...colDef,
          headerName: colDef.headerName + " - scenario",
          colId: colDef.colId + " - scenario",
          field: colDef.field + " - scenario",
          loading:
            (summary === SummaryType.ABSOLUTE && fetchingAbsSbsData) ||
            (summary === SummaryType.BENCHMARK && fetchingAbsSbsData) ||
            (summary === SummaryType.RELATIVE && fetchingRelSbsData),
          X_sbs: true,
          X_originalColId: colId,
          X_backgroundColor: "#fffb95",
        };
        colDefs.push(sbsColDef);
      }
      return colDefs;
    }, []);
  }, [
    definitions,
    dispatch,
    fetchingAbsData,
    fetchingAbsSbsData,
    fetchingRelData,
    fetchingRelSbsData,
    sideBySideValue,
  ]);
};
